export enum InsightType {
	Viewed,
	Completed
}
